module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "kp-select-open",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.boxSetActive(_vm.box);
        _vm.modalOpen('delete-box')
      }
    }
  }, [_c('i', {
    staticClass: "icon-kp-delete"
  }), _vm._v(_vm._s(_vm.$t('general.actions.delete')) + "\n")])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-af8cb8a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/list/item/ButtonDelete.vue
 ** module id = 901
 ** module chunks = 1
 **/